import {
  SET_ALL_AUTH_VALUES,
  UPDATE_ID_TOKEN,
  UPDATE,
  RESET,
  STOP_TIMER,
  HIDE_POPUP,
  SHOW_POPUP,
  SET_AUTH_VALUES_FROM_EVENT_RESP,
  TURN_ON_AUTH_DEBUG,
  TURN_OFF_AUTH_DEBUG,
  SET_LAST_AUTH,
} from "../actions/auth";
import { LOG_OUT } from "../actions/user";

const defaultState = {
  token: null,
  refreshToken: null,
  lastAuth: null,
  timeLeft: null,
  timerRunning: false,
  showPopup: false,
  showDebug: false,
};

const timeoutLength = 60 * 2 * 1000 + 5000 * 6;

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_ALL_AUTH_VALUES:
      return Object.assign({}, state, {
        token: action.token,
        refreshToken: action.refreshToken,
        lastAuth: new Date(),
        timeLeft: action.timeLeft,
        timerRunning: true,
        showPopup: false,
      });
    case SET_AUTH_VALUES_FROM_EVENT_RESP:
      return Object.assign({}, state, {
        token: action.token,
        lastAuth: new Date(),
        timeLeft: action.timeLeft,
        timerRunning: true,
        showPopup: false,
      });
    case TURN_ON_AUTH_DEBUG:
      return Object.assign({}, state, {
        showDebug: true,
      });
    case TURN_OFF_AUTH_DEBUG:
      return Object.assign({}, state, {
        showDebug: false,
      });
    case UPDATE_ID_TOKEN:
      return Object.assign({}, state, {
        token: action.token,
        lastAuth: new Date(),
      });
    case UPDATE:
      //Only apply timer interval update when timer is still running
      if (state.timerRunning) {
        const updatedTimeLeft = state.timeLeft - action.deltaTime;
        return Object.assign({}, state, {
          timeLeft: updatedTimeLeft,
        });
      } else {
        return state;
      }
    case RESET:
      return Object.assign({}, state, {
        timeLeft: timeoutLength,
        timerRunning: true,
        showPopup: false,
      });
    case STOP_TIMER:
      return Object.assign({}, state, {
        timeLeft: 0,
        timerRunning: false,
      });
    case SHOW_POPUP:
      return Object.assign({}, state, {
        showPopup: true,
      });
    case HIDE_POPUP:
      return Object.assign({}, state, {
        showPopup: false,
      });
    case LOG_OUT:
      return Object.assign({}, state, {
        token: null,
        refreshToken: null,
        lastAuth: null,
        timeLeft: null,
        timerRunning: false,
        showPopup: false,
      });
    case SET_LAST_AUTH:
      return Object.assign({}, state, {
        token: action.token,
        refreshToken: action.refreshToken,
        lastAuth: new Date(),
      });
    default:
      return Object.assign({}, state, {});
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js